const accordions = document.querySelectorAll('[data-accordion]')

accordions.forEach(accordion => {
  const showAll = accordion.querySelector('[data-accordion-show-all]')
  const togglers = accordion.querySelectorAll('[data-accordion-toggler]')
  const items = accordion.querySelectorAll('.accordion__item')
  let accordionsOpen = false;

  showAll.addEventListener('click', e => {
    e.preventDefault()

    if (accordionsOpen) {
      items.forEach(item => item.classList.remove('is-open'))
    }
    else {
      items.forEach(item => item.classList.add('is-open'))
    }

    showAll.classList.toggle('is-open')
    accordionsOpen = !accordionsOpen
  })

  togglers.forEach(toggler => {
    toggler.addEventListener('click', e => {
      e.preventDefault()
      toggler.closest('.accordion__item').classList.toggle('is-open')
    })
  })

  items.forEach(item => {
    const contentHeight = item.querySelector('.accordion__content').clientHeight
  })

})